import { axios } from "../../api/";

export default {
    state: {
        items: [],
        menu:[],
        status: "",
        result: {},
        resultParent: {}
    },
    getters: {
        items: (state) => state.items,
        menu: state => state.menu,
    },
    actions: {
        getItems({ commit }) {
            axios
                .get("/getCheckout")
                .then((res) => {
                    commit("getItemData", res.data);
                })
                .catch((err) => console.log(err));
        },
        changeStatus({ commit }, payload) {
            commit("changeStatus", payload);
        },
        changeStatusParent({ commit }, parentId) {
            commit("changeStatusParent", parentId);
        },
    },
    mutations: {
        getItemData(state, payload) {
            state.items = payload;
            window.Echo.channel('home').listen('DisplayKitchen', (e) => {
                state.items = e.home
            });
        },
        async changeStatus(state, payload){
            const [ itemId, detailId ] = payload;
            // console.log("itemId", itemId)
            // console.log("detailId", detailId)
            // console.log(payload)
            const currentItem = state.items.find((item) => item.id == itemId);
            const detailItem = currentItem.checkout_details.find((detailItem) => detailItem.id == detailId);
            const indexSelectedItem = state.items.indexOf(currentItem)
            const indexDetailItem = currentItem.checkout_details.indexOf(detailItem)
            // console.log("currentItem", currentItem)
            // console.log("detailItem", detailItem)
            // console.log("detailItemIndex", indexDetailItem)
            // console.log('items', currentItem.checkout_details[indexDetailItem].status)
            const status = state.items[indexSelectedItem].checkout_details[indexDetailItem].status
            // console.log(status)
            if (status === "accept") {
                state.items[indexSelectedItem].checkout_details[indexDetailItem].status = "on going"
            } else if (status === "on going") {
                state.items[indexSelectedItem].checkout_details[indexDetailItem].status = "done"
            } else if(status === "done"){
                state.items[indexSelectedItem].checkout_details[indexDetailItem].status = "done"
            }
            
            const change = state.items[indexSelectedItem].checkout_details[indexDetailItem].status
            // state.items[indexSelectedItem].checkout_details[indexSelectedItem].status = "Done"
            // console.log(currentItem.id);
            // console.log(currentItem.checkout_details);
            // const result = currentItem.checkout_details.find((a) => a.id === id)
            state.result = {
                change: change,
                id: detailId
            }
            // console.log(state.result);
            await axios 
                .post("/changeStatus", state.result)
                .then((res) => {
                    res
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async changeStatusParent(state, id){
            const currentItem = state.items.find((item) => item.id == id);
            state.resultParent = {
                id : currentItem.id,
                status : "done"
            }
            await axios
                .post("/changeStatusParent", state.resultParent)
                .then((res) => {
                    // console.log(res.data);
                    res
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }
}